import { type UseMutationOptions, useMutation } from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { AcceptSwapPayload } from '@/modules/Messages/types/api/payload/swap'
import type { AcceptSwapSuccessResponse } from '@/modules/Messages/types/api/response/swap'

const ENDPOINT = '/Swap/Accept'

export function acceptSwap(payload: AcceptSwapPayload) {
  return axiosInstance.post<AcceptSwapSuccessResponse>(
    ENDPOINT,
    {
      id: payload.id.value,
    },
    {
      baseURL: import.meta.env.VITE_API_OFFER_BASE_URL,
    }
  )
}

export function useAcceptSwapMutation(
  options?: UseMutationOptions<
    AxiosResponse<AcceptSwapSuccessResponse>,
    AxiosCustomError,
    AcceptSwapPayload,
    any
  >
) {
  return useMutation({
    mutationFn: (payload: AcceptSwapPayload) => acceptSwap(payload),
    ...options,
  })
}
